"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsService = void 0;
var lists_1 = require("src/lists");
var search_1 = require("src/search");
var FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
var String_utils_1 = require("src/String.utils");
var filtersConfig_1 = require("../filtersConfig");
var src_1 = require("src");
var SearchResultsService = /** @class */ (function () {
    function SearchResultsService() {
    }
    SearchResultsService.isSegmentFilterOfAnyType = function (type) {
        return (type === FullTextSearchApi_1.FullTextSearchFilters.AllSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.DocumentationSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.ProductsSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.DownloadSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.CourseSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.DrawingsSegmentFilterAlias);
    };
    SearchResultsService.getDocumentSearchPageTypeFromUrl = function () {
        var type = src_1.UrlService.GetFilterQueryValueFromUrl('type');
        switch (type) {
            case FullTextSearchApi_1.FullTextSearcherTypes.Documentation:
                return FullTextSearchApi_1.FullTextSearcherTypes.Documentation;
                break;
            case FullTextSearchApi_1.FullTextSearcherTypes.Drawings:
                return FullTextSearchApi_1.FullTextSearcherTypes.Drawings;
                break;
        }
    };
    SearchResultsService.hasGroupFilterTemplate = function (filterId) {
        return !!filtersConfig_1.GROUP_FILTER_TEMPLATE_BY_FILTER_ID[filterId];
    };
    SearchResultsService.hasGroupFilterItemTemplate = function (groupTemplate, filterType) {
        return !!SearchResultsService.getGroupFilterItemTemplate(groupTemplate, filterType);
    };
    SearchResultsService.getGroupFilterItemTemplate = function (groupTemplate, filterType) {
        return lists_1.getFirstOrDefault(groupTemplate.filters, null, function (template) {
            return String_utils_1.equalIgnoreCase(filterType, template.type);
        });
    };
    SearchResultsService.getGroupFilterTemplateByFilterId = function (filterId) {
        var template = filtersConfig_1.GROUP_FILTER_TEMPLATE_BY_FILTER_ID[filterId];
        return template || null;
    };
    SearchResultsService.getFilterOrderByTypeFilterAndId = function (typeFilterValue, filterId) {
        var filtersMappingByType = filtersConfig_1.FILTER_ORDER_MAPPING[typeFilterValue];
        var FALLBACK_ORDER = Infinity;
        return filtersMappingByType && filtersMappingByType[filterId]
            ? filtersMappingByType[filterId]
            : FALLBACK_ORDER;
    };
    SearchResultsService.getFilterValueFromQuery = function (filter, selectedValues, filterId) {
        // Get facet languages from query
        var queryValues = SearchResultsService.getValuesFromQuery(filter.query, filterId);
        // Get language value
        var result;
        if (filter.selected) {
            result = lists_1.getFirstOrDefault(selectedValues, null, function (item) { return queryValues && queryValues.indexOf(item) === -1; });
        }
        else {
            result = lists_1.getFirstOrDefault(queryValues, null, function (item) { return !selectedValues || selectedValues.indexOf(item) === -1; });
        }
        return result;
    };
    SearchResultsService.getValuesFromQuery = function (query, filterName) {
        return query
            .split('&')
            .filter(function (item) {
            var keyValue = item.split('=');
            return keyValue.length === 2 && keyValue[0] === "" + search_1.FACET_PREFIX + filterName;
        })
            .map(function (item) {
            return item.split('=')[1];
        });
    };
    SearchResultsService.getFilterKeyItself = function (filterValue, separator) {
        if (separator === void 0) { separator = ':'; }
        return filterValue ? filterValue.split(separator)[0] : '';
    };
    SearchResultsService.getFilterValueItself = function (filterValue, separator) {
        if (separator === void 0) { separator = ':'; }
        return filterValue ? filterValue.split(separator)[1] : '';
    };
    return SearchResultsService;
}());
exports.SearchResultsService = SearchResultsService;
